import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import * as moment from 'moment'

@Component({
  selector: 'app-work-sheet',
  templateUrl: './work-sheet.component.html',
  styleUrls: ['./work-sheet.component.css']
})
export class WorkSheetComponent implements OnInit {


  Submitted: boolean = false;
  BookTitleList = [];
  ChapterHeadingList = [];
  ChapterTopicList = [];
  SearchChapterHeadingList = [];
  SearchChapterTopicList = [];
  ChapterContentList = [];

  constructor(private learningservice: LearningService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  SearchModel = {
    SubjectID: 0,
    ClassID: 0,
    WorkSheetID:0,
    WorkSheetTypeID: 0,
  };

  ClearSearch() {
    this.SearchModel.ClassID = 0;
    this.SearchModel.WorkSheetTypeID = 0;
    this.SearchModel.WorkSheetID = 0;
    this.SearchModel.SubjectID = 0;
    this.WorksheetList=[];
  }
  Content: '';
  LearningModel = {
    WorkSheetID: 0,
    WorkSheetTitle: "",
    ClassID: 0,
    BookTitleID: 0,
    ChapterID: 0,
    TopicID: 0,
    QuestionCount: 0,
    WorkSheetTypeID: 0,
    Duration: 0,
    PublishDate: '',
    IsActive: true,
    IsPublish: false,
    StartTime:  moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    StartDate:'',
    StartDateTime:'',
    Maxmarks:0,
    TestType:'',
    SubjectID:0,
  };

  Clear() {
    this.LearningModel.WorkSheetID = 0;
    this.LearningModel.WorkSheetTitle = '';
    this.LearningModel.ClassID = 0;
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.ChapterID = 0;
    this.LearningModel.TopicID = 0;
    this.LearningModel.QuestionCount = 0;
    this.LearningModel.WorkSheetTypeID = 0;
    this.LearningModel.Duration = 0;
    this.LearningModel.PublishDate = '';
    this.LearningModel.StartDateTime = '';
    this.LearningModel.TestType = '';
    this.LearningModel.Maxmarks = 0;
    this.LearningModel.SubjectID=0;
    this.LearningModel.StartTime = moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.LearningModel.IsPublish = false;
    this.Submitted = false;
    this.IsSaveDisplay=false;   
    this.TopicQuestionBankList = [];
    this.SelectedQuestionList=[];
  }
  IsSaveDisplay=false;
  Edit(obj) {
    this.IsSaveDisplay=false;   
    this.MsgAlertPublish='';
    this.LearningModel.WorkSheetID = obj.WorkSheetID;
    this.LearningModel.WorkSheetTitle = obj.WorkSheetTitle;
    this.LearningModel.ClassID = obj.ClassID;
    this.GetClassSubject();
    this.LearningModel.SubjectID = obj.SubjectID;
    this.LearningModel.QuestionCount = obj.QuestionCount;
    this.LearningModel.WorkSheetTypeID = obj.WorkSheetTypeID;
    this.LearningModel.Duration = obj.Duration
    this.LearningModel.PublishDate = obj.PublishDate != null && obj.PublishDate != '' ? moment(obj.PublishDate).format('DD-MMM-YYYY') : '';
    this.LearningModel.StartDate = obj.StartDateTime != null && obj.StartDateTime != '' ? moment(obj.StartDateTime).format('DD-MMM-YYYY') : '';
    this.LearningModel.StartTime = obj.StartDateTime != null && obj.StartDateTime != '' ? moment(obj.StartDateTime).format('DD-MMM-YYYY HH:mm') : '';
    this.LearningModel.StartDateTime = obj.StartDateTime != null && obj.StartDateTime != '' ? moment(obj.StartDateTime).format('DD-MMM-YYYY HH:mm') : '';
    this.LearningModel.QuestionCount = obj.QuestionCount;
    this.LearningModel.IsActive = obj.IsActive;
    this.LearningModel.IsPublish = obj.IsPublish;
    this.LearningModel.TestType = obj.TestType;
    this.LearningModel.Maxmarks = obj.Maxmarks;
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.ChapterID = 0;
    this.LearningModel.TopicID = 0;
    if(this.LearningModel.IsPublish){
      this.IsSaveDisplay=true;
    }
    this.TopicQuestionBankList = [];
    this.MsgSelectedQuestion = '';
     this.spinnerService.show();
      this.learningservice.GetAllTestQuestions(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
        this.SelectedQuestionList = data.TestQuestionList;
        this.spinnerService.hide();       
      });
    
   
  }

  ValidityState() {
    return this.LearningModel.WorkSheetTypeID == 0 || this.LearningModel.ClassID == 0 || this.LearningModel.SubjectID == 0|| this.LearningModel.WorkSheetTitle == '' || (this.LearningModel.IsPublish && this.LearningModel.PublishDate == '')||(this.LearningModel.WorkSheetTypeID==1 && this.LearningModel.StartDate == '');
  }

  QList=[];
  MsgAlertPublish='';
  SaveWorksheet() {
    this.Submitted = true;
   this.QList=[];
   this.MsgAlertPublish='';
    if (!this.ValidityState()) {
      this.LearningModel.PublishDate = this.LearningModel.PublishDate != null && this.LearningModel.PublishDate != '' ? moment(this.LearningModel.PublishDate).format('DD-MMM-YYYY') : '';
      this.LearningModel.StartDate = this.LearningModel.StartDate != null && this.LearningModel.StartDate != '' ? moment(this.LearningModel.StartDate).format('DD-MMM-YYYY') : '';
     
      if(this.LearningModel.IsPublish==true && this.LearningModel.StartDate!='' && new Date(this.LearningModel.PublishDate)> new Date(this.LearningModel.StartDate) ){
       this.MsgAlertPublish='Publish Date can not be greater than Start Date';
        return   
      }
      if (this.LearningModel.IsPublish==false || (this.LearningModel.IsPublish && confirm("Are you sure to publish this test !"))) {
      if(this.SelectedQuestionList!=null){
        for(var i=0;i<this.SelectedQuestionList.length;i++){
          var item={
            'WSQuestionID':this.SelectedQuestionList[i].WSQuestionID,
            'QuestionID':this.SelectedQuestionList[i].QuestionID,
            'QuestionNo':this.SelectedQuestionList[i].QuestionNo,
          }
          this.QList.push(item);
        }
      }
      this.spinnerService.show();
      this.Submitted = false;
      this.LearningModel.StartTime = this.LearningModel.StartTime != null && this.LearningModel.StartTime != '' ? moment(this.LearningModel.StartTime).format('HH:mm') : '';
      this.learningservice.SaveWorksheet(JSON.stringify(this.LearningModel), JSON.stringify(this.QList)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllWorksheet();
        }
        if (data.webResponse.Status && this.LearningModel.WorkSheetID == 0) {
          this.Clear();
        }
        if (data.webResponse.Status && this.LearningModel.WorkSheetID> 0 && this.LearningModel.IsPublish) {
          this.IsSaveDisplay=true;
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  }

  };
  WorksheetList = [];
  GetAllWorksheet() {

    this.spinnerService.show();
    this.learningservice.GetAllWorksheet(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.WorksheetList = data.WorksheetList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };


  TopicQuestionBankList = [];

  GetTopicQuestionBank() {
    this.MsgSelectedQuestion = '';
    this.spinnerService.show();
    this.learningservice.GetTopicQuestionBank(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
      this.TopicQuestionBankList = data.TopicQuestionBankList;

      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });

  };
  SelectedQuestionList = [];
  MsgSelectedQuestion = '';
  GetQuestion(index, item) {   
    if (!item.IsActive) {
      this.MsgSelectedQuestion = '';
      var Count = 0;
      for (var i = 0; i < this.SelectedQuestionList.length; i++) {
        if (this.SelectedQuestionList[i].QuestionID == item.QuestionID)
          Count++;
      }
      if (Count == 0) {
        this.SelectedQuestionList.push(item)
        this.LearningModel.QuestionCount=this.LearningModel.QuestionCount+1;
        this.LearningModel.Maxmarks=this.LearningModel.Maxmarks+item.QValue;
        this.TopicQuestionBankList.splice(index, 1)
      }
      else {
        this.MsgSelectedQuestion = 'Question is already selected'
        return;
      }
    }
    else {
      this.MsgSelectedQuestion = '';
      return;
    }
  }

  DeleteWorkSheetQuestion(index,item) {      
    this.SelectedQuestionList.splice(index, 1)    
    this.LearningModel.QuestionCount=this.LearningModel.QuestionCount-1;
    this.LearningModel.Maxmarks=this.LearningModel.Maxmarks-item.QValue;
  };
  MarkActiveWorksheet(item) {
    this.LearningModel.WorkSheetID = item.WorkSheetID;
    this.LearningModel.IsActive = item.IsActive == true ? false : true;
    this.spinnerService.show();
    this.learningservice.MarkActiveWorksheet(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllWorksheet();
      }

      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  };

  InstructionModel={
    Instruction:'',
    WorkSheetID:0,
    WorkSheetTitle:'',
  }

  AddInstruction(item){
    this.InstructionModel.WorkSheetID=item.WorkSheetID;
    this.InstructionModel.Instruction=item.Instruction;
    this.InstructionModel.WorkSheetTitle=item.WorkSheetTitle;
  }

  SaveTestInstruction() {
    this.spinnerService.show();
    this.learningservice.SaveTestInstruction(this.InstructionModel.WorkSheetID,this.InstructionModel.Instruction).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllWorksheet();
      }

      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  };


  ngOnInit() {
    this.GetBookTitle();
    this.GetClass();
    this.GetWorkSheetType();
    this.GetClassTestTitle();
    this.GetSubject();
  }

  LearningSubjectList=[];
  GetClassSubject() {
    this.LearningModel.SubjectID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.ClassID
    }
    this.LookupService.GetLookupsList('LearningSubject', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.LearningSubjectList = data.LookupItems;
    });
  }

  SubjectList=[];
  GetSubject() {
    this.SearchModel.SubjectID = 0;
    var ItemBO = {
      'ItemID': this.SearchModel.ClassID
    }
    this.LookupService.GetLookupsList('LearningSubject', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectList = data.LookupItems;
    });
  }
  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }

  GetChapterHeading() {
    this.LearningModel.ChapterID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.BookTitleID
    }
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterHeadingList = data.LookupItems;
    });
  }

  GetChapterTopic() {
    this.LearningModel.TopicID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.ChapterID
    }
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterTopicList = data.LookupItems;
    });
  }
  ClassList = [];
  GetClass() {
    this.LookupService.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  }

  WorkSheetTypeList = [];
  GetWorkSheetType() {
    this.LookupService.GetLookupsList('WorkSheetType', '').subscribe((data: any) => {
      this.WorkSheetTypeList = data.LookupItems;
    });
  }

  TestTitleList=[];
  GetClassTestTitle() {
    this.SearchModel.WorkSheetID=0;
    this.WorksheetList=[];
    var ItemBO={
     'ItemID':this.SearchModel.ClassID
   }
    this.LookupService.GetLookupsList('ClassTestTitle', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.TestTitleList = data.LookupItems;
    });
  }

  ClearList(){
    this.WorksheetList=[];
  }
   // Print

   PrintStudentTest(item) {
    var url = "studenttestprint?WorksheetID=" + item.WorkSheetID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

  }

  PrintStaffTest(item) {
    var url = "stafftestprint?WorksheetID=" + item.WorkSheetID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

  }
}







